import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import ChevronRightBoldIcon from 'src/assets/images/icChevronRightBold.svg';
import Badge from 'src/components/Badge';
import BlurredUserPhotos from 'src/components/BlurredUserPhotos';
import { useDirectMessageNavigation } from 'src/components/DirectMessage/context';
import Image from 'src/components/Image';
import { useDMRecentlyAddedFriendsCountQuery } from 'src/hooks/useDirectMessageQuery';
import useFriendsPhotos from 'src/hooks/useFriendsPhotos';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
import { imageStyles, Action, Container, Content, HeaderRow, MessageText, UserName } from './styles';
const Placeholder = styled.div`
  ${imageStyles}

  background-color: ${({
  theme
}) => theme.color.surface4};

  display: flex;
  align-items: center;
  justify-content: center;
`;
const PlaceholderImage = styled(Image)`
  width: 50%;
  height: 50%;
  object-fit: contain;
`;
const MoreIcon = styled(ChevronRightBoldIcon)`
  width: 14px;
  height: 14px;

  color: ${({
  theme
}) => theme.color.content7};

  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
const StyledBlurredPhotos = styled(BlurredUserPhotos)`
  color: ${({
  theme
}) => theme.color.bg1};

  ${({
  theme
}) => theme.screenSize.desktop} {
    color: ${({
  theme
}) => theme.color.bg2};
  }
`;
type Props = Pick<ComponentProps<'li'>, 'className'>;
const FollowLinkItem = (props: Props) => {
  const {
    t
  } = useTranslation();
  const {
    openFollower
  } = useDirectMessageNavigation();
  const {
    data: recentlyAddedFriendsCount
  } = useDMRecentlyAddedFriendsCountQuery();
  const images = useFriendsPhotos(3);
  const handleOpenFollow = () => {
    pushEvent({
      eventType: EVENT_TYPE.LOG,
      eventName: EVENT_NAME.MESSAGE__OPEN_FOLLOW,
      eventParams: {
        action_category: 'open',
        tab: 'message',
        page: 'follower',
        target: 'follow',
        referrer: 'who_follows_me'
      }
    });
    openFollower();
  };
  return <Container {...props} data-sentry-element="Container" data-sentry-component="FollowLinkItem" data-sentry-source-file="FollowLink.tsx">
      <Action type='button' onClick={handleOpenFollow} data-sentry-element="Action" data-sentry-source-file="FollowLink.tsx">
        <Placeholder data-sentry-element="Placeholder" data-sentry-source-file="FollowLink.tsx">
          <PlaceholderImage src='/images/icons/imgPin.png' alt="placeholder of follow link's profile media section" data-sentry-element="PlaceholderImage" data-sentry-source-file="FollowLink.tsx" />
        </Placeholder>
        <Content data-sentry-element="Content" data-sentry-source-file="FollowLink.tsx">
          <HeaderRow data-sentry-element="HeaderRow" data-sentry-source-file="FollowLink.tsx">
            <UserName data-sentry-element="UserName" data-sentry-source-file="FollowLink.tsx">{t('message_follower_banner_title')}</UserName>
            {recentlyAddedFriendsCount != null && recentlyAddedFriendsCount > 0 && <Badge type='number' value={recentlyAddedFriendsCount} />}
            <MoreIcon data-sentry-element="MoreIcon" data-sentry-source-file="FollowLink.tsx" />
          </HeaderRow>
          <HeaderRow data-sentry-element="HeaderRow" data-sentry-source-file="FollowLink.tsx">
            <MessageText data-sentry-element="MessageText" data-sentry-source-file="FollowLink.tsx">{t('message_follower_banner_desc')}</MessageText>
          </HeaderRow>
        </Content>
        <StyledBlurredPhotos containerWidth={50} offset={10} images={images} data-sentry-element="StyledBlurredPhotos" data-sentry-source-file="FollowLink.tsx" />
      </Action>
    </Container>;
};
export default FollowLinkItem;